import { envConfig } from './config/envconfig';
declare global {
  interface Window {
    wp: any;
    php_pars: any;
    uhconfig: any;
    grecaptcha: any;
  }
}
class RecaptchaHelper {
  siteKey: string;

  constructor() {
    this.siteKey = php_pars.recaptchaSiteKey;
  }

  async getToken() {
    console.log("Fetching captcha token...");
    if (envConfig.globalMockEnabled) {
      return "mock";
    }
    return new Promise<string>((resolve, reject) => {
      window.grecaptcha.enterprise.ready(async () => {
        const token = await window.grecaptcha.enterprise.execute(this.siteKey, {
          action: "TEST",
        }).catch(console.error);
        if (typeof token == 'string') {
          resolve(token as string);
        } else {
          if (envConfig.fallbackMock)
            resolve("mock")
          else
            reject("Errore Token"); //fallback a null per non esplodere quando mockato
        }
      });
    })
  }
}

export default new RecaptchaHelper();
